import { encode, getAttachMode, isValidURL } from "@utils/helpers";
import { useEffect, useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FlexColumnGap, GenericButton, Input, Label } from "shared/ui-basics";
import styled from "styled-components/macro";

const AttachEditPopOver = ({ item, upsertAttachItem, placement = "top", open, setOpen }) => {

    const { t } = useTranslation();
    const [objectToUpdate, setUpdateObject] = useState(item);
    const attachMode = getAttachMode(item);
    useEffect(() => {
        if(item?.id !== objectToUpdate?.id)
            setUpdateObject(item);
    }, [item]);
    const checkIfValid = () => {
        if (objectToUpdate?.description.isEmptyString() || (attachMode === "link" && !isValidURL(objectToUpdate?.url)))
            return false;
        return true;
    }

    const validated = checkIfValid();
    const handleChange = (e) => {
        let { name, value } = e.target;
        setUpdateObject({ ...objectToUpdate, [name]: value });
    };
    const save = (e) => {

        const copyObject = {
            ...objectToUpdate,
            description: encode(objectToUpdate?.description),
            url: encode(objectToUpdate?.url),
            fileName: encode(objectToUpdate?.fileName)
        }
        upsertAttachItem(copyObject);
        setOpen(false);
    }
    const handle = (e) => {
        setOpen(false);
    };
    const popover = (
        <CustomPopOver className="">
            <Popover.Body className="">
                <FlexColumnGap gap='24'>
                    <div>
                        <Label className="pb-2">{t(attachMode === "file" ? "FILE_NAME" : "LINK_NAME")}</Label>
                        <Input
                            variant="default"
                            name="description"
                            type="text"
                            value={objectToUpdate?.description}
                            onChange={handleChange}
                        />
                    </div>
                    {attachMode === "link" && <div>
                        <Label className="pb-2">{t("LINK_URL")}</Label>
                        <Input
                            variant="default"
                            name="url"
                            type="text"
                            value={objectToUpdate?.url}
                            onChange={handleChange}
                        />
                    </div>}
                    <GenericButton variant="dark" onClick={save} disabled={!validated}>
                        {t("SAVE")}
                    </GenericButton>
                </FlexColumnGap>
            </Popover.Body >
        </CustomPopOver>
    );
    return (
        <div id="editAttach" >
            <OverlayTrigger show={open} onToggle={handle} trigger={["click"]} placement={placement} overlay={popover} rootClose={true} >
                <div />
            </OverlayTrigger>
        </div>
    );
}
AttachEditPopOver.displayName = "AttachEditPopOver";

export default AttachEditPopOver;
const CustomPopOver = styled(Popover)`
	/* max-width: 400px; */
	z-index: 1001;
    box-shadow: 1px 8px 16px 0px rgba(0, 0, 0, 0.15);
    .popover-arrow {
        display:none;
}
`;

const WrapperButton = styled.div`
    :hover{
        background-color: #efefef !important;

    }
`